/** Page size for Materialien / Leistungen browse and keyword search. */
export const STAMMDATEN_LIST_PAGE_SIZE = 100;
